import { render, staticRenderFns } from "./Navmenu.vue?vue&type=template&id=20294576&scoped=true"
import script from "./Navmenu.vue?vue&type=script&lang=js"
export * from "./Navmenu.vue?vue&type=script&lang=js"
import style0 from "./Navmenu.vue?vue&type=style&index=0&id=20294576&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20294576",
  null
  
)

export default component.exports